import React from "react"
import {
  HStack, Button, Divider, Popover, PopoverTrigger, PopoverContent,
  PopoverBody, Input, VStack, Portal,
} from "@chakra-ui/react"
import { HexColorPicker } from "react-colorful"
import {
  Control, FieldPath, FieldValues, useController,
} from "react-hook-form"
import ColorCircle from "./ColorCircle"

type Props<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  control: Control<T>
  swatches: string[]
}

const ColorSwatchPicker = <T extends FieldValues = FieldValues>({
  name, control, swatches,
}: Props<T>) => {
  const { field } = useController<T, FieldPath<T>>({ control, name })
  const value = (field.value as string) || ""

  return (
    <HStack spacing={2} align="center">
      {swatches.map((color) => (
        <ColorCircle
          key={color}
          color={color}
          selected={value.toLowerCase() === color.toLowerCase()}
          onSelect={field.onChange}
        />
      ))}
      <Divider orientation="vertical" h={6} borderColor="gray.300" />
      <Popover placement="bottom-start">
        <PopoverTrigger>
          <Button
            p={0}
            w={7}
            h={7}
            minWidth="none"
            borderRadius="full"
            borderColor="gray.400"
            borderWidth={1}
            bgImage="conic-gradient(from 0deg, #F36566, #EE8935, #EDCA4B, #48BB79, #41B2AC, #49C5EA, #4399E1, #9F7BEA, #EE65A6, #F36566)"
            aria-label="Pick a custom color"
            _hover={{ opacity: 0.8 }}
            _focus={{}}
          />
        </PopoverTrigger>
        <Portal>
          <PopoverContent w="220px">
            <PopoverBody>
              <VStack spacing={3} align="stretch">
                <HexColorPicker
                  color={value || "#000000"}
                  onChange={field.onChange}
                />
                <Input
                  size="sm"
                  value={value}
                  onChange={(e) => field.onChange(e.target.value)}
                  placeholder="#000000"
                />
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    </HStack>
  )
}

export default ColorSwatchPicker
